@if (optionsFetched) {
    <div class="row action-toolbar" style="margin-top: 15px">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="burnRateGrid"></action-toolbar-count>
                <grid-export [grid]="gridBurnRate" [name]="'Fuel Burn Rate'"></grid-export>
                <div class="input-header-group">
                    <span class="input-header">Year</span>
                    <wj-combo-box
                        id="burnRateYear"
                        style="width: 100px"
                        [(ngModel)]="selectedYear"
                        (ngModelChange)="onYearChange()"
                        name="burnRateYear"
                        [itemsSource]="yearOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
                <div class="input-header-group">
                    <span class="input-header">Month</span>
                    <wj-combo-box
                        id="burnRateMonth"
                        style="width: 150px"
                        [(ngModel)]="selectedMonth"
                        (ngModelChange)="onMonthChange()"
                        name="burnRateMonth"
                        [itemsSource]="monthOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                @if (selectedMonth !== null) {
                    <div class="input-header-group">
                        <span class="input-header">Day</span>
                        <wj-combo-box
                            id="burnRateDay"
                            style="width: 100px"
                            [(ngModel)]="selectedDay"
                            (ngModelChange)="onDayChange()"
                            name="burnRateDay"
                            [itemsSource]="dayOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                }
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <grid-column-group [grid]="burnRateGrid"></grid-column-group>
            <wj-flex-grid
                id="gridBurnRate"
                #gridBurnRate
                appAutoSize
                [padding]="73"
                (initialized)="burnRateGrid.initialize(gridBurnRate)"
                [itemsSource]="burnRateGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="250"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Category'" [binding]="'equipmentCategory'" [width]="350"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Total Gallons'"
                    [binding]="'totalGallons'"
                    [width]="150"
                    [format]="'N2'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Total Hours'"
                    [binding]="'totalHours'"
                    [width]="150"
                    [format]="'N2'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Gal/Hr'"
                    [binding]="'gallonsPerHour'"
                    [width]="150"
                    [format]="'N2'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
            <grid-selection-calculation [grid]="gridBurnRate"></grid-selection-calculation>
        </div>
    </div>
}
